export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9656.965e70a0.jpg";